import * as TabsPrimitive from '@radix-ui/react-tabs';
import * as React from 'react';

import { cn } from '@lib/utils';

const Tabs = TabsPrimitive.Root;

const TabsList = (props: React.ComponentProps<typeof TabsPrimitive.List>) => {
  const { className, ...otherProps } = props;

  return (
    <TabsPrimitive.List
      className={cn(
        'inline-flex h-10 items-center justify-center rounded-md bg-muted p-1 text-muted-foreground',
        className,
      )}
      {...otherProps}
    />
  );
};
TabsList.displayName = TabsPrimitive.List.displayName;

const TabsTrigger = (props: React.ComponentProps<typeof TabsPrimitive.Trigger>) => {
  const { className, ...otherProps } = props;

  return (
    <TabsPrimitive.Trigger
      className={cn(
        'inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm',
        className,
      )}
      {...otherProps}
    />
  );
};
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName;

const TabsContent = (props: React.ComponentProps<typeof TabsPrimitive.Content>) => {
  const { className, ...otherProps } = props;

  return (
    <TabsPrimitive.Content
      className={cn(
        'mt-2 ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
        className,
      )}
      {...otherProps}
    />
  );
};
TabsContent.displayName = TabsPrimitive.Content.displayName;

export { Tabs, TabsList, TabsTrigger, TabsContent };
